import React from 'react'
import BallySportsNHL from 'src/components/page/bally-sports-nhl'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsNHL
    location={props.location}
    video={videos.bally_redwings.videoUrl}
    staticAnnotation={videos.bally_redwings.staticAnnotation}
    title="Watch Detroit hockey live"
    subtitle="Stream the Red Wings on FanDuel Sports Network Detroit"
    sportId={sportIds.Hockey}
    leagueId={leagueIds.NHL}
    teamId={teamIds['Detroit Red Wings']}
  />
)
